export const WebinarRoles = {
    Host: "host",
    ActiveHost: "active_host",
    Speaker: "speaker",
    ActiveSpeaker: "active_speaker",
    Listener: "listener",
    TempListener: "temp_listener",
    ActiveTempListener: "active_temp_listener",
    Default: "default",
};
